import "./styles/global.css";

import { ReactNode } from "react";
import { MainTheme } from "@/shared/theme";
import { ApplicationSettingsProvider } from "@/application/providers/application-settings";
import Routes from "./routes/routes";
import { NotificationProvider } from "@/shared/feedback/notification";
import { ModuleProvider } from "@/shared/modules";
import { AntdStyleProvider } from "./providers/antd-style-provider";
import { GraphQlProvider } from "@/shared/graphql";
import { ErrorBoundary } from "./providers/error-boundary";
import { LocalizationProvider } from "@/shared/i18n";
import { PublicRoutes } from "@/application/routes/public-routes";

export default function App() {
  return (
    <Infrastructure>
      <NotRequiredAuthorization>
        <PublicRoutes>
          <Routes />
        </PublicRoutes>
      </NotRequiredAuthorization>
    </Infrastructure>
  );
}

function NotRequiredAuthorization({ children }: { children: ReactNode }) {
  return (
    <ApplicationSettingsProvider>
      <MainTheme>
        <ModuleProvider>{children}</ModuleProvider>
      </MainTheme>
    </ApplicationSettingsProvider>
  );
}

function Infrastructure({ children }: { children: ReactNode }) {
  return (
    <LocalizationProvider>
      <ErrorBoundary>
        <GraphQlProvider>
          <AntdStyleProvider>
            <NotificationProvider>{children}</NotificationProvider>
          </AntdStyleProvider>
        </GraphQlProvider>
      </ErrorBoundary>
    </LocalizationProvider>
  );
}
